import { throwError,  Observable ,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { HttpClient, HttpResponse } from '@angular/common/http';


@Injectable()
export class HeaderService {

    public globalSearchUrl: string;

    private globalSearchObserver: Subject<any>;

    private globalSearchNotifier: Observable<any>;

    public constructor(private readonly http: HttpClient) {
        this.globalSearchObserver = new Subject<any>();
        this.globalSearchNotifier = this.globalSearchObserver.asObservable();
        this.globalSearchUrl = `${AppSettings.API_ENDPOINTS.get('IACDataServices')}/protected/searchService/global?criteria=`;
    }

    public updateSearchInput(input: string) {
        this.globalSearchObserver.next({input: input, func: "input"});
    }

    public updateSearchView(input: string) {
        this.globalSearchObserver.next({input: input, func: "view"});
    }

    public registerSearchUpdates(callback: any) {
        return this.globalSearchNotifier.subscribe(callback);
    }

    public globalSearch(searchText: string): Promise<any> {
        return this.http.get(`${this.globalSearchUrl}${searchText}`)
                        .toPromise()
                        .then((res:HttpResponse<any>) => res);
    }

    private handleError(error: HttpResponse<any>) {
        console.error(error);
        return throwError(() => new Error(JSON.stringify(error) || 'Server Error'));
    }

}